import {useState} from 'react';
import {makeStyles} from '@mui/styles';
import {FormHelperText, RadioGroup} from '@mui/material';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';

import styles from 'assets/jss/FormikField.js';
import {
  StyledFormControlLabel,
  AccordionDetails,
  AccordionSummary,
  Accordion,
} from 'assets/jss/FormikAccordion';
const useStyles = makeStyles(styles);

const RadioBtn = (
  <Radio
    sx={{
      color: 'rgba(172, 172, 172, 0.5)',
      '& .MuiSvgIcon-root': {
        fontSize: 20,
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    }}
  />
);

function RadioField(props) {
  const classes = useStyles();
  const {name, items, errors, values, setFieldValue, label} = props;

  const [expanded, setExpanded] = useState(false);
  const acordionChangeHandler = () => setExpanded((prev) => !prev);

  const radioGroupHandler = (event) => {
    const {value} = event?.target;

    const booleanType = value === 'true' ? true : false;
    const numberType = parseInt(value);

    const setStateInitialValues =
      value === 'true' || value === 'false'
        ? booleanType
        : typeof +value === 'number'
        ? numberType
        : value;

    setFieldValue(name, setStateInitialValues);
    acordionChangeHandler();

  
    if (name === 'diabetType' && value == 2) {
      setFieldValue('isPregnant', true);
      setFieldValue('isMale', false);
    }

    if (name === 'isMale') {
      if (value == 'false' && values?.diabetType == 2) {
        setFieldValue('isPregnant', true);
      }
      if (value == 'true' && values?.diabetType == 2) {
        setFieldValue('diabetType', null);
      }
      if (value == 'true' && values?.isPregnant !== null) {
        setFieldValue('isPregnant', null);
      }
    }
  };

  const selectedValue = items?.find((item) => item?.value === values[name]);

  return (
    <Accordion expanded={expanded} onChange={acordionChangeHandler}>
      <AccordionSummary aria-controls='panel1d-content' id='panel1d-header'>
        <span className={classes.markerStyle}>{label} :</span>
        <p className={classes.sickName}>
          {selectedValue ? selectedValue?.label : '_'}
        </p>
      </AccordionSummary>
      <AccordionDetails sx={{pb: '0.5rem', pt: '0'}}>
        <Grid container>
          <FormControl>
            <RadioGroup
              row
              name={name}
              disableRipple
              value={values[name]}
              onChange={radioGroupHandler}>
              {items?.map((item, index) => (
                <StyledFormControlLabel
                  key={index}
                  sx={{width: '100%'}}
                  value={item?.value}
                  label={item?.label}
                  control={RadioBtn}
                  checked={values[name] === item?.value}
                  activeItem={values[name] === item?.value}
                />
              ))}
            </RadioGroup>
            {errors[name] && <FormHelperText>{errors[name]}</FormHelperText>}
          </FormControl>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default RadioField;
